import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CustomUserState, StateWithCustomUser } from '../user-state';
import { getCustomUserState } from './feature.selector';

export const getLegalEntityStatus: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getCustomUserState,
  (state: CustomUserState) => state.legalEntityStatus,
);
